import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '../../../common/Card/Card';
import styles from './AlertCard.module.css';
import redArrow from '../../../../Assets/arred.gif';
import yellowArrow from '../../../../Assets/argreen.gif';
import greenArrow from '../../../../Assets/argreen.gif';


export const AlertCard = ({ priority, openCount, closedCount, trend, isSelected, onClick }) => {
  return (
    <Card 
      className={`${styles.alertCard} ${isSelected ? styles.selected : ''} ${onClick ? styles.clickable : ''}`}
      onClick={onClick}
    >
      <div className={styles.topRow}>
        {/* Priority + Alerts label */}
        <div className={styles.labelSection}>
          <h3
            className={`${styles.priority} ${
              priority.toLowerCase() === 'p1'
                ? styles.p1
                : priority.toLowerCase() === 'p2'
                ? styles.p2
                : priority.toLowerCase() === 'p3'
                ? styles.p3
                : styles.p4
            }`}
          >
            {priority}
          </h3>
          <span className={styles.alerts}>Alerts</span>
        </div>

        {/* Trend arrow */}
        <div
          className={`${styles.metricBox} ${styles.trend} ${
            trend === 'up'
              ? styles.trendUp
              : trend === 'down'
              ? styles.trendDown
              : styles.trendBalanced
          }`}
        >
          {trend === 'up' && <img src={redArrow} alt="Up trend" className={styles.trendIcon} class="redarrow" />}
          {trend === 'down' && <img src={greenArrow} alt="Down trend" className={styles.trendIcon} class="greenarrow" />}
          {trend === 'balanced' && <img src={yellowArrow} alt="Balanced trend" className={styles.trendIcon} class="yellowarrow" />}
        </div>
      </div>

      {/* Bottom row: Open & Closed counts */}
      <div className={styles.bottomRow}>
        <div className={`${styles.metricBox} ${styles.open}`}>
          <span className={styles.value}>{openCount}</span>
          <span className={styles.label}>Triggered</span>
        </div>
        <div className={`${styles.metricBox} ${styles.closed}`}>
          <span className={styles.value}>{closedCount}</span>
          <span className={styles.label}>Resolved</span>
        </div>
      </div>
    </Card>
  );
};

AlertCard.propTypes = {
  priority: PropTypes.string.isRequired,
  openCount: PropTypes.number.isRequired,
  closedCount: PropTypes.number.isRequired,
  trend: PropTypes.oneOf(['up', 'down', 'balanced']).isRequired,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
};